// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3gXw_","info":"PatientInfo_info__12aib"};